import React from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import arkansasImage from '../../images/arkansas.png';
import missouriIMage from '../../images/missouri.png';

const AboutPage = () => {
  return (
    <div>
      <Container fluid={true}>
        <Row>
          <Col md={12}>
            <h1 className="text-center my-4">About RK Water Operations</h1>
          </Col>
        </Row>

        <Row>
          <Col md={1} />
          <Col md={10}>
            <p>
              RK Water is a full-service firm providing quality operation,
              management, and repair services for water and wastewater systems.
              We have been involved in the operation of systems, large and
              small, for over {new Date().getFullYear() - 1994} years. We have
              an excellent working relationship with Arkansas Department of
              Health, Arkansas Department of Environmental Quality, and Missouri
              Department of Natural Resources.
            </p>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="my-4">
            <hr className="featurette-divider" />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <h2 className="text-center my-4">Licenses</h2>
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-4">
            <ListGroup className="text-center">
              <ListGroupItem>
                <h3>Arksansas</h3>
                <img
                  className="img-fluid mx-auto d-block"
                  src={arkansasImage}
                  alt="Arkansas Licenses"
                />
              </ListGroupItem>
              <ListGroupItem>Water Treatment Operator-Grade 4</ListGroupItem>
              <ListGroupItem>Water Distribution Operator-Grade 4</ListGroupItem>
              <ListGroupItem>
                Wastewater Treatment Operator-Grade 3
              </ListGroupItem>
              <ListGroupItem>Certified Plumbing Inspector</ListGroupItem>
            </ListGroup>
          </Col>
          <Col md={6} className="mb-4">
            <ListGroup className="text-center">
              <ListGroupItem>
                <h3>Missouri</h3>
                <img
                  className="img-fluid mx-auto d-block"
                  src={missouriIMage}
                  alt="Missouri Licenses"
                />
              </ListGroupItem>
              <ListGroupItem>Water Distribution Operator-Level 3</ListGroupItem>
              <ListGroupItem>
                Wastewater Treatment Operator-Level B
              </ListGroupItem>
            </ListGroup>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutPage;



// WEBPACK FOOTER //
// ./src/components/about/AboutPage.js